(() => {
  const roots = document.querySelectorAll('[data-cart-checkout]');
  if (!roots.length) return;

  // Kaching reemplaza window.fetch con su propio interceptor de carrito (confirmado 2026-09-25
  // via window.fetch.toString() en vivo). Los cambios de carrito que este archivo hace por su
  // cuenta (togglear suscripcion, cantidad, remover) necesitan llegar a Shopify tal cual - pasar
  // por el interceptor de Kaching puede alterar o perder el selling_plan silenciosamente. Se usa
  // el fetch nativo real que layout/theme.liquid guarda en window._dhNativeFetch ANTES de que
  // Kaching cargue y lo reemplace; si por algun motivo no esta disponible, cae al fetch actual
  // (que puede ya estar parcheado, pero es mejor que romper del todo).
  const cartFetch = (...args) => (window._dhNativeFetch || window.fetch)(...args);

  roots.forEach((root) => {
    const launcher = document.querySelector('[data-cart-checkout-open]');
    const overlay = document.querySelector('[data-cart-checkout-overlay]');
    const closeBtn = root.querySelector('[data-cart-checkout-close]');
    const primaryCard = root.querySelector('[data-primary-product-card]');
    const removePrimaryBtn = root.querySelector('[data-remove-primary]');
    const qtyNode = root.querySelector('[data-qty]');
    const subtotalNode = root.querySelector('[data-subtotal]');
    const unitPriceNode = root.querySelector('[data-unit-price-cents]');
    const primaryTitleNode = root.querySelector('[data-primary-title]');
    const primaryThumbNode = root.querySelector('[data-primary-thumb]');
    const comparePriceNode = root.querySelector('[data-compare-price-cents]');
    const saveNode = root.querySelector('[data-save-amount-cents]');
    const discountNode = root.querySelector('[data-discount-amount]');
    const couponInput = root.querySelector('[data-coupon-input]');
    const checkoutLink = root.querySelector('[data-checkout-link]');
    const checkoutLinkDefaultLabel = checkoutLink ? checkoutLink.textContent : '';
    const countdownNode = root.querySelector('[data-countdown]');
    let featuredSlides = Array.from(root.querySelectorAll('[data-featured-slide]'));
    let featuredDots = Array.from(root.querySelectorAll('[data-featured-dot]'));
    const addButtons = Array.from(root.querySelectorAll('[data-add-to-cart]'));
    const upsellPlanMap = {};
    addButtons.forEach((btn) => {
      const variantId = Number(btn.dataset.variantId || 0);
      const planId = Number(btn.dataset.subPlanId || 0);
      const priceCents = Number(btn.dataset.subPriceCents || 0);
      const interval = btn.dataset.subInterval || '';
      const oneTimePriceCents = Number(btn.dataset.priceCents || 0);
      const comparePriceCents = Number(btn.dataset.comparePriceCents || 0);
      if (variantId) {
        upsellPlanMap[variantId] = {
          planId,
          priceCents,
          interval,
          oneTimePriceCents,
          comparePriceCents
        };
      }
    });
    Array.from(root.querySelectorAll('[data-variant-price-data]')).forEach((el) => {
      const variantId = Number(el.dataset.variantId || 0);
      if (variantId && !upsellPlanMap[variantId]) {
        upsellPlanMap[variantId] = {
          planId: Number(el.dataset.subPlanId || 0),
          priceCents: Number(el.dataset.subPriceCents || 0),
          interval: el.dataset.subInterval || '',
          oneTimePriceCents: Number(el.dataset.priceCents || 0),
          comparePriceCents: Number(el.dataset.comparePriceCents || 0)
        };
      }
    });
    const featuredTrack = root.querySelector('.dh-cart-checkout__featured-track');
    const secondaryProductsNode = root.querySelector('[data-secondary-products]');
    const emptyStateNode = root.querySelector('[data-empty-state]');
    const itemsScrollNode = root.querySelector('[data-items-scroll]');
    const itemsScrollThumb = root.querySelector('[data-items-scroll-thumb]');
    const primaryVariantIdFromSection = Number(root.dataset.primaryVariantId || 0) || 0;
    const subToggleWrap = root.querySelector('[data-sub-toggle-wrap]');
    const subToggleCheckbox = root.querySelector('[data-sub-toggle]');
    const couponToggleBtn = root.querySelector('[data-coupon-toggle]');
    const couponPanel = root.querySelector('[data-coupon-panel]');

    let qty = 1;
    let featuredIndex = 0;
    let primaryRemoved = false;
    let primaryInCart = false;
    let closeTimer = null;
    let secondaryCartItems = [];
    let secondaryOneTimePriceMap = {};
    let secondarySubPlanCache = {};
    let secondaryFetchedHandles = new Set();
    let featuredAutoplayTimer = null;
    let featuredTransitionTimer = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchDeltaX = 0;
    let isTouchTracking = false;
    let lockedScrollY = 0;
    const unitCents = Number(primaryCard ? primaryCard.dataset.baseUnitPriceCents : (unitPriceNode ? unitPriceNode.dataset.unitPriceCents : 0)) || 0;
    const compareCents = Number(primaryCard ? primaryCard.dataset.baseComparePriceCents : (comparePriceNode ? comparePriceNode.dataset.comparePriceCents : 0)) || 0;
    const subPlanId = Number(primaryCard ? primaryCard.dataset.subPlanId : 0) || 0;
    const subPriceCents = Number(primaryCard ? primaryCard.dataset.subPriceCents : 0) || 0;
    let effectiveSubPriceCents = subPriceCents;
    const initialPrimaryState = {
      finalCents: unitCents,
      compareCents,
      compareText: primaryCard ? (primaryCard.dataset.baseCompareText || '') : (comparePriceNode ? comparePriceNode.textContent.replace(/\s+/g, ' ').trim() : ''),
      saveText: primaryCard ? (primaryCard.dataset.baseSaveText || '') : (saveNode ? saveNode.textContent.replace(/\s+/g, ' ').trim() : ''),
      titleText: primaryTitleNode ? primaryTitleNode.textContent.replace(/\s+/g, ' ').trim() : '',
      imageSrc: primaryThumbNode ? (primaryThumbNode.currentSrc || primaryThumbNode.src || '') : '',
      imageAlt: primaryThumbNode ? (primaryThumbNode.getAttribute('alt') || '') : ''
    };
    let primaryPricingState = { ...initialPrimaryState };
    let subscriptionActive = false;
    // Se marca en cuanto el cliente toca el toggle del drawer. Sirve para no pisar esa eleccion
    // cada vez que se reabre el drawer (initSubscriptionToggle reinicia el estado leyendo el
    // selling plan de la PAGINA de producto, que no cambia al togglear dentro del drawer -
    // confirmado 2026-07-27: se activaba la suscripcion, se cerraba el drawer y al reabrirlo
    // volvia a aparecer apagada).
    let subscriptionUserOverride = false;
    let nonKachingCompareCents = 0;
    let kachingPerUnitCache = { oneTime: 0, withSub: 0, detected: false };
    let kachingDealsCache = { promise: null, timestamp: 0 };
    const KACHING_DEALS_CACHE_MS = 60000;
    let timeLeftMs = (Number(root.dataset.timerSeconds || 560) || 560) * 1000;
    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const featuredAutoplayDelay = 3600;
    const featuredTransitionDuration = 360;

    const money = (cents) => {
      try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
      } catch (e) {}
      return '$' + (cents / 100).toFixed(2);
    };

    const parseMoneyTextToCents = (value) => {
      if (!value) return 0;
      const normalized = String(value).replace(/\s+/g, ' ').trim();
      const match = normalized.match(/([$??])?\s*\d+(?:[.,]\d{2})/g);
      if (!match || !match.length) return 0;
      const last = match[match.length - 1].replace(/[^0-9.,]/g, '').replace(',', '.');
      const amount = Number.parseFloat(last);
      return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
    };

    const normalizeImageSrc = (value) => {
      if (!value) return '';
      if (typeof value === 'string') return value;
      if (typeof value === 'object') {
        return value.url || value.src || value.image || '';
      }
      return '';
    };

    const isKachingBundlesPage = () => !!document.querySelector('.kaching-bundles, .kaching-bundles__block, .kaching-bundles__bars');

    // Kaching NO tiene una barra de suscripcion con precio propio: la card "Suscribete y
    // ahorra" (dentro de .kaching-bundles__subscriptions) no tiene ningun .kaching-bundles__bar-price
    // adentro (confirmado 2026-07-28 inspeccionando el DOM en vivo). Lo que hace es pisar el
    // .kaching-bundles__bar-price de la barra de CANTIDAD ya seleccionada (ej. "Compra 2 + 1
    // Gratis") con el precio con descuento de suscripcion cuando esa card queda --selected. Osea
    // que ese mismo nodo de precio muestra el valor de una vez O el de suscripcion segun el
    // estado de esa card, nunca los dos.
    //
    // IMPORTANTE (2026-07-28): NO intentar deducir del DOM cual de las dos cards esta activa.
    // Kaching renderiza exactamente dos cards -N("one-time") y N("subscribe")- y ninguna lleva
    // clase propia que las distinga, solo .kaching-bundles__bar--selected. Ubicarlas por posicion
    // (:last-child) es incorrecto: el orden se invierte cuando la oferta tiene subscribeByDefault
    // activo (visible en kaching-bundles-block.js: `subscribeByDefault ? oneTimeTitle : subscribeTitle`).
    // En Apple Cider y Fat Burner (subscribeByDefault: true) esa deteccion daba el estado al reves,
    // el precio de suscripcion entraba como precio de una vez y se le volvia a restar el % del
    // plan -> $61.32 en vez de $69.33 en la barra 2+1.
    //
    // La fuente correcta es la LINEA DEL CARRITO: si tiene selling_plan_allocation, el widget
    // estaba en modo suscripcion al agregar y el precio del bar es el de suscripcion; si no lo
    // tiene, es el de una vez. Ese estado no se puede invertir. Ver el bloque de Kaching en
    // updateSecondaryProductsFromCart.

    // La clase real que Kaching pone en el bar elegido es .kaching-bundles__bar--selected (no
    // .kaching-bundles__block--selected/.selected/.active - esos nunca existieron en el DOM real).
    // NO puede tener un fallback sin scope al grupo :not(.kaching-bundles__subscriptions): si el
    // cliente eligio "Suscribete y ahorra", ninguna barra de ese grupo queda con radio marcado ni
    // con --selected, y un fallback global terminaba encontrando la card de suscripcion (que si
    // tiene --selected) en vez de devolver "no hay barra de una vez seleccionada".
    const getSelectedQuantityBarPriceCents = () => {
      const checkedRadio = document.querySelector('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) input[type="radio"]:checked');
      const bar = (checkedRadio && checkedRadio.closest('.kaching-bundles__bar'))
        || document.querySelector('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) .kaching-bundles__bar.kaching-bundles__bar--selected');
      if (!bar) return 0;
      const priceNode = bar.querySelector('.kaching-bundles__bar-price');
      if (!priceNode) return 0;
      return parseMoneyTextToCents(priceNode.textContent || '');
    };


    // fetchDeals() pega a los servidores de Kaching (fuera de nuestro control) y el drawer lo
    // llamaba de cero en cada apertura/actualizacion del carrito, aunque las ofertas casi nunca
    // cambian durante una misma sesion de compra - era una de las causas de la lentitud al abrir
    // el drawer (confirmado 2026-09-14). Se cachea la promesa por 60s; si fetchDeals() falla se
    // descarta el cache para no dejar clavado un error.
    const fetchKachingDealsCached = () => {
      const now = Date.now();
      if (kachingDealsCache.promise && (now - kachingDealsCache.timestamp) < KACHING_DEALS_CACHE_MS) {
        return kachingDealsCache.promise;
      }
      const promise = window.kachingBundlesApi.fetchDeals().catch((e) => {
        kachingDealsCache = { promise: null, timestamp: 0 };
        throw e;
      });
      kachingDealsCache = { promise, timestamp: now };
      return promise;
    };

    const fetchKachingOneTimePricePerUnit = async (qty, baseUnitCents) => {
      try {
        if (!window.kachingBundlesApi || typeof window.kachingBundlesApi.fetchDeals !== 'function') {
          return 0;
        }
        const deals = await fetchKachingDealsCached();
        if (!Array.isArray(deals)) return 0;
        for (const deal of deals) {
          const bar = Array.isArray(deal.dealBars) ? deal.dealBars.find(b => b.quantity === qty) : null;
          if (!bar) continue;
          const discountType = (bar.discount && bar.discount.type) || bar.discountType || '';
          const discountValueRaw = (bar.discount && bar.discount.value) ?? bar.discountValue ?? 0;
          // Bundles configurados con descuento "specific" (precio TOTAL fijo para el bundle, ej.
          // Slim Boost "Compra 2 + 1 Gratis": $178.00 por las 3 unidades) no son un % sobre
          // baseUnitCents - discountPct quedaba en 0 y esta funcion devolvia baseUnitCents tal
          // cual (el precio SIN descontar), inflando el precio "sin suscripcion" mostrado al
          // togglear la suscripcion en el drawer (confirmado 2026-09-25: ~$300 en vez de $178
          // para esa barra). Formula tomada del propio codigo de Kaching (funcion xa() en
          // kaching-bundles-block.js): el discountValue esta en dolares y es el TOTAL para la
          // cantidad de esa barra, no un valor por unidad.
          if (discountType === 'specific') {
            const totalCents = Math.round(Number(discountValueRaw || 0) * 100);
            if (totalCents > 0 && qty > 0) return Math.round(totalCents / qty);
            return 0;
          }
          const discountPct = discountType === 'percentage' ? Number(discountValueRaw || 0) : 0;
          // Kaching redondea el precio por unidad HACIA ARRIBA, no al mas cercano (confirmado
          // 2026-07-28 contra los precios reales del cliente): Apple Cider barra 3+2 es
          // 3900 x (1 - 39.45%) = 2361.45 -> 2362 -> $118.10, mientras que Math.round daba
          // 2361 -> $118.05. Con base $45.00 el bug quedaba tapado porque 4500 x 0.6055 = 2724.75
          // ya redondeaba hacia arriba igual ($136.25) - por eso solo se vio en Apple Cider.
          return Math.ceil(baseUnitCents * (1 - discountPct / 100));
        }
      } catch (e) {
      }
      return 0;
    };

    const getPreferredProductImage = () => {
      const selectors = [
        '.dh-main-product__slide:not([hidden]) .dh-main-product__image',
        '.dh-main-product__track .dh-main-product__image',
        '.dh-main-product__image:not(.dh-main-product__image--placeholder)',
        '.dh-mpv2__slide:not([hidden]) .dh-mpv2__image',
        '.dh-mpv2__track .dh-mpv2__image',
        '.dh-mpv2__image:not(.dh-mpv2__image--placeholder)',
        'form[action*="/cart/add"] img[src]'
      ];

      for (const selector of selectors) {
        const imageNode = document.querySelector(selector);
        if (!imageNode || imageNode.classList.contains('dh-main-product__image--placeholder') || imageNode.classList.contains('dh-mpv2__image--placeholder')) continue;
        const src = normalizeImageSrc(imageNode.currentSrc || imageNode.src || imageNode.getAttribute('src'));
        if (src) {
          return {
            src,
            alt: imageNode.getAttribute('alt') || ''
          };
        }
      }

      return {
        src: initialPrimaryState.imageSrc,
        alt: initialPrimaryState.imageAlt
      };
    };

    const getBasePricingFromProductPage = () => {
      const pricingNode = document.querySelector('[data-product-price-cents]');
      const compareNode = document.querySelector('.dh-main-product__price-compare, .dh-mpv2__price-compare');
      const saveNodeText = document.querySelector('.dh-main-product__save, .dh-mpv2__save');
      const titleNode = document.querySelector('.dh-main-product__title, .dh-mpv2__title');
      const preferredImage = getPreferredProductImage();

      const baseFinalCents = pricingNode ? (Number(pricingNode.dataset.productPriceCents) || 0) : 0;
      const baseCompareCents = pricingNode ? (Number(pricingNode.dataset.productCompareCents) || 0) : 0;
      // getSelectedQuantityBarPriceCents() devuelve el TOTAL del bundle seleccionado, no el
      // precio por unidad - aca no sabemos por cuanta cantidad dividir (eso solo se sabe una vez
      // que updateSecondaryProductsFromCart lee cartQty del carrito real). Usarlo aca sin dividir
      // causaba $271.35 en vez de $90.45 justo al abrir el drawer (confirmado 2026-07-27). Se deja
      // el precio regular como estimado inicial; el bloque de Kaching en updateSecondaryProductsFromCart
      // lo corrige enseguida con el valor real ya dividido por cartQty.

      return {
        finalCents: baseFinalCents || initialPrimaryState.finalCents,
        compareCents: baseCompareCents > 0 ? baseCompareCents : initialPrimaryState.compareCents,
        compareText: compareNode ? compareNode.textContent.replace(/\s+/g, ' ').trim() : initialPrimaryState.compareText,
        saveText: saveNodeText ? saveNodeText.textContent.replace(/\s+/g, ' ').trim() : initialPrimaryState.saveText,
        titleText: titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : initialPrimaryState.titleText,
        imageSrc: preferredImage.src || initialPrimaryState.imageSrc,
        imageAlt: preferredImage.alt || initialPrimaryState.imageAlt
      };
    };

    const capturePrimaryPricingState = () => {
      const basePricing = getBasePricingFromProductPage();
      const pageSellingPlanId = getPrimarySellingPlanId();
      const isSubSelected = pageSellingPlanId > 0 && effectiveSubPriceCents > 0;

      primaryPricingState = {
        finalCents: isSubSelected ? effectiveSubPriceCents : basePricing.finalCents,
        compareCents: basePricing.compareCents,
        compareText: basePricing.compareText,
        saveText: basePricing.saveText,
        titleText: basePricing.titleText,
        imageSrc: basePricing.imageSrc,
        imageAlt: basePricing.imageAlt
      };
      return primaryPricingState;
    };

    const syncCartCountBadge = (count) => {
      document.querySelectorAll('cart-count').forEach((badge) => {
        // El componente nativo <cart-count> del tema borra este span (this.textContent = count)
        // cada vez que actualiza el numero por su cuenta (ej. en el evento "pageshow" al volver
        // del checkout con el boton atras) - sin este fallback, syncCartCountBadge dejaba de
        // poder actualizar el icono hasta recargar la pagina (confirmado 2026-09-14).
        const visibleSpan = badge.querySelector('span[aria-hidden="true"]');
        if (visibleSpan) {
          visibleSpan.textContent = String(count);
        } else {
          badge.textContent = String(count);
        }
        badge.classList.toggle('opacity-0', count === 0);
      });
    };

    const formHasSellingPlanInput = () => !!(
      document.querySelector('.dh-main-product form[action*="/cart/add"] input[name="selling_plan"]') ||
      document.querySelector('.dh-mpv2 form[action*="/cart/add"] input[name="selling_plan"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="selling_plan"]')
    );

    const kachingSubscriptionBar = () => document.querySelector('.kaching-bundles__subscriptions .kaching-bundles__bar:last-child');

    const hasKachingSubscriptionOption = () => !!kachingSubscriptionBar();


    const detectAvailableSubPriceCents = () => {
      const baseCents = getBasePricingFromProductPage().finalCents || unitCents;
      if (!baseCents) return 0;
      const targeted = document.querySelector('[data-selling-plan-id], [class*="kaching-sub"], [class*="selling-plan-option"]');
      if (targeted) {
        const c = parseMoneyTextToCents(targeted.textContent || '');
        if (c > baseCents * 0.5 && c < baseCents) return c;
      }
      // Kaching Bundles no usa <input> real para la opcion de suscripcion (la seleccion se marca
      // con la clase .bar--selected en .kaching-bundles__bar, ver kaching-bundles-custom.css
      // seccion 8) - "Suscribete y ahorra" es siempre el ultimo .bar dentro de .subscriptions.
      const kachingBar = kachingSubscriptionBar();
      if (kachingBar) {
        const priceNode = kachingBar.querySelector('.kaching-bundles__bar-price');
        const c = priceNode ? parseMoneyTextToCents(priceNode.textContent || '') : 0;
        if (c > 0 && c < baseCents) return c;
      }
      for (const el of document.querySelectorAll('label:has(input[type="radio"]), [role="radio"]')) {
        const text = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!/subscription|suscripci/i.test(text)) continue;
        const c = parseMoneyTextToCents(text);
        if (c > baseCents * 0.5 && c < baseCents) return c;
      }
      return 0;
    };

    const formatSellingPlanName = (name) => {
      if (!name) return '';
      const units = { day: ['day', 'days'], week: ['week', 'weeks'], month: ['month', 'months'], year: ['year', 'years'] };
      const disc = (name.match(/([\d.]+)%\s*off/i) || [])[1];
      const discStr = disc ? ` · ${parseFloat(disc)}% off` : '';
      const m = name.match(/every\s+(\d+)\s+(day|week|month|year)s?/i) ||
                name.match(/every\s+(day|week|month|year)s?/i) ||
                name.match(/(\d+)[- ](day|week|month|year)s?/i);
      if (m) {
        let n, u;
        if (!m[2]) { n = 1; u = m[1].toLowerCase(); }
        else { n = Number(m[1]); u = m[2].toLowerCase(); }
        const label = (units[u] || [u, u + 's'])[n === 1 ? 0 : 1];
        return n === 1 ? `Every ${label}${discStr}` : `Every ${n} ${label}${discStr}`;
      }
      return name;
    };

    // El campo selling_plan.name que sincroniza Kaching Subscriptions a veces viene mal escrito
    // (ej. "Delivery: every month" en un plan configurado para cada 4 meses - confirmado
    // 2026-09-14 con Gut Boost Pro, plan 692424245552: el grupo se llama bien "4-Month
    // Subscription" pero el plan individual quedo con el nombre del plan mensual). El dato REAL
    // si viaja completo en selling_plan.options[] (name: "config"), un JSON con
    // delivery.interval/delivery.frequency que /cart.js expone tal cual - se arma el texto desde
    // ahi en vez de parsear el nombre, que es lo que puede estar mal etiquetado en origen.
    const formatSellingPlanFromConfig = (sellingPlan) => {
      const configOption = sellingPlan && Array.isArray(sellingPlan.options)
        ? sellingPlan.options.find((o) => o && o.name === 'config')
        : null;
      if (!configOption || !configOption.value) return '';
      let config;
      try {
        config = JSON.parse(configOption.value);
      } catch (e) {
        return '';
      }
      const delivery = config && config.delivery;
      const frequency = delivery && Number(delivery.frequency);
      const interval = delivery && String(delivery.interval || '').toLowerCase();
      if (!frequency || !interval) return '';
      const units = { day: ['day', 'days'], week: ['week', 'weeks'], month: ['month', 'months'], year: ['year', 'years'] };
      const label = (units[interval] || [interval, interval + 's'])[frequency === 1 ? 0 : 1];
      const discountValue = config.discount && config.discount.adjustmentValue;
      const discStr = discountValue ? ` · ${parseFloat(discountValue)}% off` : '';
      return frequency === 1 ? `Every ${label}${discStr}` : `Every ${frequency} ${label}${discStr}`;
    };

    // Fuente preferida para el texto del intervalo: el config real del plan (ver comentario de
    // formatSellingPlanFromConfig arriba) - si no esta disponible (apps distintas a Kaching
    // Subscriptions, o el campo options ausente), cae al parseo del nombre de siempre.
    const getSellingPlanIntervalText = (sellingPlan) => {
      const fromConfig = formatSellingPlanFromConfig(sellingPlan);
      if (fromConfig) return fromConfig;
      return formatSellingPlanName(sellingPlan && sellingPlan.name);
    };

    // Kaching Bundles no muestra en ningun lado el texto armado "Cada mes - X% dto." - hay que
    // sacarlo del selling plan real del producto (mismo mecanismo que fetchAndCacheSecondaryPlanIds
    // usa para los upsells, pero nunca se implemento para el producto primario porque section.settings.product
    // de este drawer global esta en blanco a proposito - el producto "primario" cambia segun la
    // pagina en la que este el cliente).
    const parseSellingPlanIntervalCount = (name) => {
      if (!name) return null;
      const m = name.match(/every\s+(\d+)\s+(day|week|month|year)s?/i) ||
                name.match(/every\s+(day|week|month|year)s?/i) ||
                name.match(/(\d+)[- ](day|week|month|year)s?/i);
      if (!m) return null;
      return m[2] ? Number(m[1]) : 1;
    };

    // El % del selling plan ya viene dentro de la propia linea de /cart.js
    // (selling_plan_allocation.selling_plan.price_adjustments), asi que se puede leer sin ningun
    // fetch y ademas corresponde al plan que Shopify va a cobrar de verdad, no al que se adivina
    // por cantidad. Se usa como fuente primaria del % de suscripcion; fetchPrimarySellingPlanInfo
    // queda de respaldo (ver nota en el bloque de Kaching de updateSecondaryProductsFromCart).
    const getSellingPlanAdjustmentPct = (spAlloc) => {
      const plan = spAlloc && spAlloc.selling_plan;
      const adjustments = plan && Array.isArray(plan.price_adjustments) ? plan.price_adjustments : null;
      const adjustment = adjustments && adjustments.length ? adjustments[0] : null;
      if (!adjustment || adjustment.value_type !== 'percentage') return 0;
      return Number(adjustment.value) || 0;
    };

    // El intervalo de suscripcion de Kaching Bundles escala con la cantidad del bar elegido
    // (Compra 1 -> cada 1 mes, Compra 2+1 -> cada 3 meses, Compra 3+2 -> cada 5 meses), asi que
    // hay que matchear el selling plan cuyo intervalo coincide con "qty" (cantidad real del item
    // en el carrito), no asumir que siempre es el primero del array.
    // IMPORTANTE: variant.selling_plan_allocations[].price (de Shopify) aplica el % del plan
    // sobre el precio REGULAR de la variante - Shopify no sabe nada del descuento de bundle de
    // Kaching, asi que ese precio NO sirve (confirmado 2026-07-27: daba $119.37 para la barra 2
    // en vez de $79.98, porque aplicaba 11.57% sobre $135 -precio sin bundle- en vez de sobre
    // $90.45 -precio con bundle-). El calculo correcto, verificado contra lo que Kaching muestra
    // en su propio widget al togglear "Suscribete y ahorra", es:
    //   precio_con_suscripcion = precio_bundle_sin_suscripcion x (1 - % del selling plan)
    // Por eso esta funcion devuelve el % del plan (price_adjustments), no un precio ya calculado.
    const fetchPrimarySellingPlanInfo = async (targetQty) => {
      const handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
      if (!handle) return null;
      try {
        // Timeout duro: se observo 2026-07-27 que este fetch puede tardar 9+ segundos o directo
        // quedarse colgado (probablemente por el header Clear-Site-Data que dispara Kaching en
        // cada request, invalidando prefetchCache/prerenderCache). Sin este limite, el await
        // bloqueaba el resto de updateSecondaryProductsFromCart (incluido el sync() final) de forma
        // indefinida, dejando el precio mostrado trabado en el valor viejo.
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 4000);
        let resp;
        try {
          resp = await fetch(`${Shopify.routes.root}products/${handle}.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: controller.signal });
        } finally {
          clearTimeout(timeoutId);
        }
        if (!resp.ok) return null;
        const product = await resp.json();
        const groups = product.selling_plan_groups;
        if (!Array.isArray(groups) || !groups.length) return null;
        // Kaching Bundles crea UN grupo de selling plan por cada duracion (1/3/5 meses,
        // confirmado 2026-07-27 con /products/berberine.js) - hay que juntar los planes de
        // TODOS los grupos, no solo del primero.
        const plans = groups.reduce((acc, g) => acc.concat(g.selling_plans || []), []);
        if (!plans.length) return null;
        const matchedPlan = targetQty
          ? plans.find((p) => parseSellingPlanIntervalCount(p.name) === targetQty)
          : null;
        const plan = matchedPlan || plans[0];
        const adjustment = Array.isArray(plan.price_adjustments) ? plan.price_adjustments[0] : null;
        const adjustmentPct = (adjustment && adjustment.value_type === 'percentage') ? Number(adjustment.value) || 0 : 0;
        return {
          planId: Number(plan.id) || 0,
          name: plan.name || '',
          adjustmentPct
        };
      } catch (e) {
        return null;
      }
    };

    // A diferencia de fetchPrimarySellingPlanInfo (que adivina el plan contando "meses" en el
    // nombre e igualandolo a la cantidad), esto lee el plan que Shopify tiene REALMENTE asociado
    // a la variante - necesario para bundles tipo "quantity-break" donde cada barra agrega una
    // VARIANTE distinta en vez de la misma variante en mas cantidad (confirmado 2026-09-25 via el
    // metafield deal_blocks de Kaching: en Slim Boost, "Compra 2 + 1 Gratis" agrega la variante
    // "2" x3, no la variante "1" x3 - y esa variante solo tiene asociado el plan de 6 meses en
    // Shopify, la variante "1" solo el de 2 meses). No se puede leer esto de
    // input[name="selling_plan"] del formulario (ver getPrimarySellingPlanId): ese input solo
    // Kaching lo llena cuando su widget de suscripcion EN LA PAGINA esta activo - si el producto
    // se agrego de una vez y recien se togglea la suscripcion en el drawer, el widget de la
    // pagina nunca se activo y el input queda vacio o deshabilitado (confirmado 2026-09-25: el
    // toggle del drawer seguia mostrando el plan fijo de 2 meses en Slim Boost pese al fix
    // anterior). La variante en si SI se conoce siempre (getPrimaryVariantId() / el variant_id
    // real de la linea del carrito), asi que se resuelve el plan a partir de ahi.
    const primaryVariantPlanCache = {};
    const fetchPrimarySubscriptionInfoForVariant = async (variantId) => {
      if (!variantId) return null;
      if (primaryVariantPlanCache[variantId]) return primaryVariantPlanCache[variantId];
      const handle = (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
      if (!handle) return null;
      try {
        // Mismo timeout duro que fetchPrimarySellingPlanInfo (ver ese comentario): este fetch a
        // /products/<handle>.js puede tardar 9+ segundos o colgarse, probablemente por el header
        // Clear-Site-Data que Kaching dispara en cada request. Esta funcion se agrego despues y
        // quedo sin el mismo guard - como se llama con await desde updateSecondaryProductsFromCart
        // (que corre en cada apertura del drawer), un colgado aca bloqueaba el render del resto
        // del drawer (items secundarios, sync()) indefinidamente.
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 4000);
        let resp;
        try {
          resp = await fetch(`${Shopify.routes.root}products/${handle}.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, signal: controller.signal });
        } finally {
          clearTimeout(timeoutId);
        }
        if (!resp.ok) return null;
        const product = await resp.json();
        const variant = (product.variants || []).find((v) => Number(v.id) === variantId);
        const alloc = variant && Array.isArray(variant.selling_plan_allocations) ? variant.selling_plan_allocations[0] : null;
        if (!alloc || !alloc.selling_plan_id) return null;
        const groups = product.selling_plan_groups;
        const plans = Array.isArray(groups) ? groups.reduce((acc, g) => acc.concat(g.selling_plans || []), []) : [];
        const plan = plans.find((p) => Number(p.id) === Number(alloc.selling_plan_id));
        const adjustment = plan && Array.isArray(plan.price_adjustments) ? plan.price_adjustments[0] : null;
        const info = {
          planId: Number(alloc.selling_plan_id) || 0,
          name: plan ? getSellingPlanIntervalText(plan) : '',
          adjustmentPct: (adjustment && adjustment.value_type === 'percentage') ? Number(adjustment.value) || 0 : 0
        };
        primaryVariantPlanCache[variantId] = info;
        return info;
      } catch (e) {
        return null;
      }
    };

    const initSubscriptionToggle = async () => {
      if (!subToggleWrap) return;
      const pageSellingPlanId = getPrimarySellingPlanId();

      if (!effectiveSubPriceCents && (subPlanId > 0 || formHasSellingPlanInput() || hasKachingSubscriptionOption())) {
        const detected = detectAvailableSubPriceCents();
        if (detected > 0) effectiveSubPriceCents = detected;
      }

      const hasSubscription = subPlanId > 0 || effectiveSubPriceCents > 0 || formHasSellingPlanInput() || hasKachingSubscriptionOption();
      subToggleWrap.hidden = !hasSubscription;
      if (!hasSubscription) return;

      // Si el cliente ya eligio explicitamente en el toggle del drawer, se respeta esa eleccion
      // al reabrirlo en vez de volver a derivarla del selling plan de la pagina de producto.
      if (!subscriptionUserOverride) {
        subscriptionActive = pageSellingPlanId > 0;
      }
      if (subToggleCheckbox) subToggleCheckbox.checked = subscriptionActive;

      // Fallback: solo entra aca si el bloque de Kaching en updateSecondaryProductsFromCart no
      // llego a rellenar el texto (paginas sin Kaching Bundles). No se recalcula el precio aca
      // porque para eso hace falta el precio de bundle ya calculado (kachingPerUnitCache.oneTime),
      // que solo existe en ese otro bloque.
      const intervalNode = root.querySelector('[data-sub-interval-text]');
      if (intervalNode && !intervalNode.textContent.trim()) {
        const info = await fetchPrimarySellingPlanInfo(qty);
        if (info && info.name) intervalNode.textContent = info.name;
      }
      if (intervalNode && intervalNode.textContent.trim()) {
        intervalNode.textContent = formatSellingPlanName(intervalNode.textContent.trim());
      }

      // Si el bloque de Kaching en updateSecondaryProductsFromCart ya calculo el precio real del
      // bundle (kachingPerUnitCache.oneTime), hay que respetarlo - getBasePricingFromProductPage()
      // devuelve el precio REGULAR de la pagina, sin el descuento de bundle, y esta funcion corre
      // justo despues del calculo de Kaching (sin await real cuando el texto del intervalo ya
      // esta lleno), asi que pisaba el precio correcto con el regular sin descuento (confirmado
      // 2026-07-27: $90.45 -> $135.00 apenas terminaba de calcularse bien).
      const baseCents = (kachingPerUnitCache.detected && kachingPerUnitCache.oneTime > 0)
        ? kachingPerUnitCache.oneTime
        : (getBasePricingFromProductPage().finalCents || unitCents);
      // effectiveSubPriceCents es un precio generico por-unidad (pensado para comprar de a 1) -
      // para productos de Kaching Bundles hay que priorizar kachingPerUnitCache.withSub, que ya
      // viene calculado especificamente para el bundle/cantidad actual (ver updateSecondaryProductsFromCart).
      // Sin esto, la primera vez que se abre el drawer con suscripcion activa multiplicaba el
      // precio de 1 unidad por la cantidad del bundle (confirmado 2026-07-28: $39.99 x 3 en vez
      // de $79.98 para "Compra 2 + 1 Gratis").
      const subCents = (kachingPerUnitCache.detected && kachingPerUnitCache.withSub > 0)
        ? kachingPerUnitCache.withSub
        : effectiveSubPriceCents;
      primaryPricingState = {
        ...primaryPricingState,
        finalCents: subscriptionActive && subCents > 0 ? subCents : baseCents
      };
    };

    // Antes esto era un solo forEach que por cada slide escribia estilos, LEIA offsetHeight
    // (forzando reflow sincronico) y volvia a escribir - con los 6 productos recomendados que
    // tiene configurados el carrito (config/settings_data.json) eran 6 reflows forzados seguidos,
    // uno por slide, justo en el momento en que arranca la transicion CSS de apertura del drawer
    // (openDrawer la llama de forma sincronica antes de que el navegador pinte el primer frame de
    // la animacion transform) - layout thrashing clasico, candidato fuerte para el "se traba al
    // abrir" reportado. Separar en dos pasadas (todas las escrituras, despues todas las lecturas)
    // deja un unico reflow para las 6 slides en vez de 6.
    const syncFeaturedTrackHeight = () => {
      if (!featuredTrack || !featuredSlides.length) return;

      const previousStyles = featuredSlides.map((slide) => ({
        visibility: slide.style.visibility,
        pointerEvents: slide.style.pointerEvents
      }));

      featuredSlides.forEach((slide) => {
        slide.hidden = false;
        slide.style.visibility = 'hidden';
        slide.style.pointerEvents = 'none';
      });

      let tallestSlide = 0;
      featuredSlides.forEach((slide) => {
        tallestSlide = Math.max(tallestSlide, slide.offsetHeight);
      });

      featuredSlides.forEach((slide, index) => {
        slide.style.visibility = previousStyles[index].visibility;
        slide.style.pointerEvents = previousStyles[index].pointerEvents;
      });

      featuredTrack.style.height = Math.max(tallestSlide, 98) + 'px';
    };

    const stopFeaturedAutoplay = () => {
      if (featuredAutoplayTimer) {
        window.clearInterval(featuredAutoplayTimer);
        featuredAutoplayTimer = null;
      }
    };

    const renderFeaturedCarousel = () => {
      if (!featuredSlides.length || !featuredTrack) return;

      if (featuredTransitionTimer) {
        window.clearTimeout(featuredTransitionTimer);
        featuredTransitionTimer = null;
      }

      featuredTrack.style.transform = `translateX(-${featuredIndex * 100}%)`;

      featuredSlides.forEach((slide, index) => {
        const isActive = index === featuredIndex;
        slide.hidden = false;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      featuredDots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === featuredIndex);
        dot.setAttribute('aria-current', index === featuredIndex ? 'true' : 'false');
      });

      requestAnimationFrame(syncFeaturedTrackHeight);
    };

    const goToFeaturedSlide = (nextIndex) => {
      if (featuredSlides.length < 2) return;
      const boundedIndex = ((nextIndex % featuredSlides.length) + featuredSlides.length) % featuredSlides.length;
      if (boundedIndex === featuredIndex) return;
      featuredIndex = boundedIndex;
      renderFeaturedCarousel();
    };

    const startFeaturedAutoplay = () => {
      if (featuredSlides.length < 2 || !root.classList.contains('is-open')) return;
      stopFeaturedAutoplay();
      featuredAutoplayTimer = window.setInterval(() => {
        goToFeaturedSlide(featuredIndex + 1);
      }, featuredAutoplayDelay);
    };

    const closeKachingCart = () => {
      const candidates = Array.from(document.querySelectorAll('[id*="kaching"], [class*="kaching"], [class*="kc-"]'));

      candidates.forEach((el) => {
        if (!el || !el.isConnected) return;
        if (el.closest && el.closest('[data-cart-checkout]')) return;
        if (el.closest && el.closest('.dh-main-product__kaching-drawer-widget, [data-kaching-drawer-widget], .dh-main-product-landing')) return;

        const descriptor = `${el.id || ''} ${el.className || ''} ${el.getAttribute && (el.getAttribute('role') || '')} ${el.getAttribute && (el.getAttribute('aria-label') || '')}`.trim();
        const looksLikeOverlay = /cart|drawer|overlay|modal|popup/i.test(descriptor);
        const isDialog = (el.getAttribute && (el.getAttribute('aria-modal') === 'true' || el.getAttribute('role') === 'dialog')) || false;
        if (!looksLikeOverlay && !isDialog) return;

        const closeButtons = el.matches('button, [role="button"]') ? [el] : Array.from(el.querySelectorAll('button, [role="button"], [aria-label*="close" i], [aria-label*="cerrar" i], [class*="close" i]'));
        const clicked = closeButtons.some((button) => {
          const label = ((button.getAttribute && (button.getAttribute('aria-label') || button.getAttribute('title'))) || button.textContent || '').trim();
          const looksLikeClose = /close|cerrar|x/i.test(label) || /close/i.test(button.className || '');
          if (!looksLikeClose) return false;
          button.click();
          return true;
        });

        if (!clicked) {
          el.setAttribute('aria-hidden', 'true');
          el.classList.remove('open', 'opened', 'active', 'visible', 'show', 'is-open');
          el.style.display = 'none';
          el.style.visibility = 'hidden';
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
        }
      });
    };


    const addRecommendedVariant = async (variantId, sellingPlanId = 0) => {
      window._dhSuppressCartOpen = true;
      try {
        const addBody = { id: variantId, quantity: 1 };
        if (sellingPlanId) addBody.selling_plan = sellingPlanId;
        const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(addBody)
        });

        const responseJson = await response.json();
        if (!response.ok) {
          throw new Error(responseJson && responseJson.description ? responseJson.description : 'Could not add to cart');
        }
        if (typeof window._dhTrackAddToCart === 'function') {
          window._dhTrackAddToCart(responseJson);
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        await updateSecondaryProductsFromCart(cartContent);
        setTimeout(closeKachingCart, 30);
        setTimeout(closeKachingCart, 250);
        return cartContent;
      } finally {
        window._dhSuppressCartOpen = false;
      }
    };

    const syncDiscounts = () => {
      if (!discountNode) return;
      const primaryCardVisible = !primaryRemoved && primaryInCart && getPrimaryVariantId() !== 0;
      const effectiveFinalCents = primaryCardVisible ? (primaryPricingState.finalCents || unitCents) : 0;
      const effectiveCompareCents = primaryPricingState.compareCents || compareCents;
      const primarySavings = primaryCardVisible ? Math.max(0, (effectiveCompareCents - effectiveFinalCents) * qty) : 0;
      const secondarySavings = secondaryCartItems.reduce((total, item) => {
        const comparePrice = Number(item.compare_at_price || 0);
        const originalLinePrice = Number(item.original_line_price || 0);
        const finalPrice = Number(item.final_line_price || 0);
        const itemQty = Number(item.quantity || 1);
        const compareSavings = comparePrice > 0 ? Math.max(0, comparePrice * itemQty - finalPrice) : 0;
        const discountSavings = originalLinePrice > 0 ? Math.max(0, originalLinePrice - finalPrice) : 0;
        return total + Math.max(compareSavings, discountSavings);
      }, 0);
      const totalSavings = primarySavings + secondarySavings;
      discountNode.textContent = totalSavings > 0 ? '-' + money(totalSavings) : '-';
    };

    const sync = () => {
      if (qtyNode) qtyNode.textContent = String(qty);
      const decreaseButton = root.querySelector('[data-decrease]');
      const increaseButton = root.querySelector('[data-increase]');
      const effectivePricing = primaryPricingState;
      const primaryCardVisible = !primaryRemoved && primaryInCart && getPrimaryVariantId() !== 0;
      const effectiveFinalCents = primaryCardVisible ? (effectivePricing.finalCents || unitCents) : 0;
      const effectiveCompareCents = effectivePricing.compareCents || compareCents;
      const productTotal = effectiveFinalCents * qty;
      const secondaryItemsTotal = getSecondaryItemsTotalCents();

      if (primaryCard) {
        primaryCard.hidden = !primaryCardVisible;
      }
      if (emptyStateNode) {
        emptyStateNode.hidden = primaryCardVisible || secondaryCartItems.length > 0;
      }
      const kachingActive = isKachingBundlesPage() && primaryCardVisible;
      if (decreaseButton) {
        const isDisabled = qty <= 1 || !primaryCardVisible || kachingActive;
        decreaseButton.disabled = isDisabled;
        decreaseButton.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
      }
      if (increaseButton) {
        increaseButton.disabled = kachingActive;
        increaseButton.setAttribute('aria-disabled', kachingActive ? 'true' : 'false');
      }
      if (unitPriceNode) {
        unitPriceNode.textContent = money(productTotal);
      }
      if (primaryTitleNode && effectivePricing.titleText) {
        primaryTitleNode.textContent = effectivePricing.titleText;
      }
      if (primaryThumbNode && effectivePricing.imageSrc) {
        primaryThumbNode.src = effectivePricing.imageSrc;
        primaryThumbNode.setAttribute('src', effectivePricing.imageSrc);
        primaryThumbNode.setAttribute('alt', effectivePricing.imageAlt || effectivePricing.titleText || '');
      }
      if (comparePriceNode) {
        comparePriceNode.hidden = !primaryCardVisible || !(effectiveCompareCents > effectiveFinalCents);
        if (!comparePriceNode.hidden) {
          comparePriceNode.textContent = money(effectiveCompareCents * qty);
        }
      }
      if (saveNode) {
        const primarySaveCents = Math.max(0, (effectiveCompareCents - effectiveFinalCents) * qty);
        saveNode.hidden = !primaryCardVisible || primarySaveCents <= 0;
        if (!saveNode.hidden) {
          saveNode.textContent = `You save ${money(primarySaveCents)}`;
        }
      }
      if (subtotalNode) {
        subtotalNode.textContent = money(productTotal + secondaryItemsTotal);
      }
      syncDiscounts();
    };

    const syncCoupon = () => {
      const code = (couponInput && couponInput.value ? couponInput.value.trim() : '').toUpperCase();
      if (checkoutLink) checkoutLink.href = code ? '/checkout?discount=' + encodeURIComponent(code) : '/checkout';
    };

    const getPrimaryVariantId = () => {
      const selectors = [
        '.dh-main-product form[action*="/cart/add"] input[name="id"]:not([disabled])',
        '.dh-main-product input[name="id"]:not([disabled])',
        '.dh-mpv2 form[action*="/cart/add"] input[name="id"]:not([disabled])',
        '.dh-mpv2 input[name="id"]:not([disabled])',
        'form[action*="/cart/add"]:not(.dh-all-products-tabs__form) input[name="id"]:not([disabled])',
        'form:not(.dh-all-products-tabs__form) input[name="id"]:not([disabled])'
      ];

      for (const selector of selectors) {
        const input = document.querySelector(selector);
        const value = Number(input && input.value ? input.value : 0) || 0;
        if (value) return value;
      }

      return primaryVariantIdFromSection;
    };

    const getPrimarySellingPlanId = () => {
      const selectors = [
        '.dh-main-product form[action*="/cart/add"] input[name="selling_plan"]:checked',
        '.dh-main-product form[action*="/cart/add"] input[name="selling_plan"]:not([disabled])[type="hidden"]',
        '.dh-mpv2 form[action*="/cart/add"] input[name="selling_plan"]:checked',
        '.dh-mpv2 form[action*="/cart/add"] input[name="selling_plan"]:not([disabled])[type="hidden"]',
        'form[action*="/cart/add"]:not(.dh-all-products-tabs__form) input[name="selling_plan"]:checked',
        'form[action*="/cart/add"]:not(.dh-all-products-tabs__form) input[name="selling_plan"]:not([disabled])[type="hidden"]'
      ];

      for (const selector of selectors) {
        const input = document.querySelector(selector);
        const value = Number(input && input.value ? input.value : 0) || 0;
        if (value) return value;
      }

      return 0;
    };

    const sellingPlanMatches = (lineItem, sellingPlanId) => {
      const lineSellingPlanId = Number(lineItem && lineItem.selling_plan_allocation && lineItem.selling_plan_allocation.selling_plan ? lineItem.selling_plan_allocation.selling_plan.id : 0) || 0;
      return lineSellingPlanId === sellingPlanId;
    };

    const isPrimaryCartItem = (lineItem) => {
      const primaryVariantId = getPrimaryVariantId();
      return Number(lineItem && lineItem.variant_id ? lineItem.variant_id : 0) === primaryVariantId;
    };

    const getSecondaryItemsTotalCents = () => secondaryCartItems.reduce((total, item) => {
      const finalLine = Number(item.final_line_price || 0) || 0;
      if (finalLine > 0) return total + finalLine;
      const vId = Number(item.variant_id || 0);
      const planInfo = upsellPlanMap[vId] || null;
      const qty = Number(item.quantity || 1) || 1;
      const spCompare = Number(item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price || 0) || 0;
      const cached = secondaryOneTimePriceMap[vId] || 0;
      const fallbackPU = Math.max(
        Number(item.compare_at_price || 0) || 0,
        Number(planInfo && planInfo.comparePriceCents || 0) || 0,
        Number(planInfo && planInfo.oneTimePriceCents || 0) || 0,
        spCompare,
        cached
      );
      return total + fallbackPU * qty;
    }, 0);

    const shouldUnlockProgress = () => (getPrimaryVariantId() !== 0 && primaryInCart && !primaryRemoved) || secondaryCartItems.length > 0;

    const updateProgressLockState = (shouldUnlock, { animate = false } = {}) => {
      root.classList.remove('is-animating', 'is-filled', 'is-progress-locked');

      if (!shouldUnlock) {
        root.classList.add('is-progress-locked');
        return;
      }

      if (animate) {
        requestAnimationFrame(() => {
          root.classList.add('is-animating');
          window.setTimeout(() => {
            root.classList.remove('is-animating');
            root.classList.add('is-filled');
          }, 1700);
        });
      } else {
        root.classList.add('is-filled');
      }
    };

    const updateSecondaryProductQuantity = async (lineKey, quantity) => {
      if (!lineKey) return;
      const nextQuantity = Math.max(0, Number(quantity || 0) || 0);
      const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: nextQuantity
        })
      });
      const cartData = await response.json();
      if (!response.ok) {
        throw new Error(cartData && cartData.description ? cartData.description : 'Could not update the quantity');
      }
      await updateSecondaryProductsFromCart(cartData);
    };

    const renderSecondaryProducts = () => {
      if (!secondaryProductsNode) return;

      if (!secondaryCartItems.length) {
        root.classList.remove('has-secondary-items');
        secondaryProductsNode.hidden = true;
        secondaryProductsNode.innerHTML = '';
        return;
      }

      root.classList.add('has-secondary-items');
      secondaryProductsNode.hidden = false;
      secondaryProductsNode.innerHTML = secondaryCartItems.map((item) => {
        const imageSrc = normalizeImageSrc(item.image) || normalizeImageSrc(item.featured_image);
        const title = item.product_title || item.title || 'Product';
        const itemVariantId = Number(item.variant_id || 0);
        const quantity = Number(item.quantity || 1) || 1;
        const planInfo = upsellPlanMap[itemVariantId] || null;
        const comparePriceCents = Number(item.compare_at_price || 0) || Number(planInfo && planInfo.comparePriceCents) || 0;
        const oneTimePriceCents = Number(planInfo && planInfo.oneTimePriceCents) || 0;
        const finalPriceCents = Number(item.final_price || 0) || 0;
        const originalLinePriceCents = Number(item.original_line_price || 0) || 0;
        const finalLinePriceCents = Number(item.final_line_price || 0) || 0;
        const spCompareAtPrice = Number(item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price || 0) || 0;
        if (spCompareAtPrice > 0) secondaryOneTimePriceMap[itemVariantId] = spCompareAtPrice;
        const spAlloc = item.selling_plan_allocation;
        if (spAlloc && spCompareAtPrice === 0) {
          const spSubPrice = Number(spAlloc.price || 0);
          if (spSubPrice > 0) {
            let derivedOneTime = 0;
            const spAdjs = spAlloc.selling_plan && spAlloc.selling_plan.price_adjustments;
            if (Array.isArray(spAdjs) && spAdjs.length > 0) {
              const adj = spAdjs[0];
              if (adj.value_type === 'percentage' && adj.value > 0) {
                derivedOneTime = Math.ceil(spSubPrice * 100 / (100 - adj.value));
              } else if (adj.value_type === 'fixed_amount' && adj.value > 0) {
                derivedOneTime = spSubPrice + adj.value;
              }
            }
            if (!derivedOneTime) {
              const planNameStr = (spAlloc.selling_plan && spAlloc.selling_plan.name) || '';
              const pctMatch = planNameStr.match(/(\d+)\s*%/);
              if (pctMatch) {
                const pct = Number(pctMatch[1]);
                if (pct > 0 && pct < 100) derivedOneTime = Math.ceil(spSubPrice * 100 / (100 - pct));
              }
            }
            if (derivedOneTime > 0) secondaryOneTimePriceMap[itemVariantId] = derivedOneTime;
          }
        }
        const cachedOneTimeCents = secondaryOneTimePriceMap[itemVariantId] || 0;
        const referenceUnitPriceCents = Math.max(comparePriceCents, oneTimePriceCents, finalPriceCents, spCompareAtPrice, cachedOneTimeCents);
        const referenceLinePriceCents = referenceUnitPriceCents > 0 ? referenceUnitPriceCents * quantity : 0;
        const displayLinePriceCents = finalLinePriceCents > 0 ? finalLinePriceCents : referenceLinePriceCents;
        const discountLineCents = finalLinePriceCents > 0
          ? Math.max(referenceLinePriceCents - finalLinePriceCents, originalLinePriceCents - finalLinePriceCents, 0)
          : 0;
        const linePrice = money(displayLinePriceCents);
        const compareLineMarkup = referenceLinePriceCents > displayLinePriceCents
          ? `<span class="dh-cart-checkout__old">${money(referenceLinePriceCents)}</span>`
          : '';
        const saveMarkup = discountLineCents > 0
          ? `<span class="dh-cart-checkout__save">You save ${money(discountLineCents)}</span>`
          : '';
        const escapedTitle = String(title)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
        const imageMarkup = imageSrc
          ? `<img class="dh-cart-checkout__thumb" src="${imageSrc}" alt="${escapedTitle}" loading="lazy" width="96" height="96">`
          : '<div class="dh-cart-checkout__thumb dh-cart-checkout__thumb--placeholder" aria-hidden="true"></div>';

        const variantId = Number(item.variant_id || 0);
        const hasPlan = !!(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
        const planInfoForVariant = upsellPlanMap[variantId];
        const cachedSubPlan = secondarySubPlanCache[variantId];
        const effectivePlanId = (planInfoForVariant && planInfoForVariant.planId) || (cachedSubPlan && cachedSubPlan.planId) || 0;
        const hasSubAvailable = hasPlan || effectivePlanId > 0;
        const intervalText = hasPlan
          ? getSellingPlanIntervalText(item.selling_plan_allocation.selling_plan)
          : (planInfoForVariant && planInfoForVariant.interval ? formatSellingPlanName(planInfoForVariant.interval) : (cachedSubPlan && cachedSubPlan.name ? formatSellingPlanName(cachedSubPlan.name) : ''));
        const subToggleMarkup = hasSubAvailable ? `
          <label class="dh-cart-checkout__sub-toggle" data-secondary-sub-toggle="${item.key}" data-variant-id="${variantId}" style="cursor:pointer">
            <span class="dh-cart-checkout__sub-switch" aria-hidden="true">
              <input type="checkbox" class="dh-cart-checkout__sub-checkbox" ${hasPlan ? 'checked' : ''} tabindex="-1">
              <span class="dh-cart-checkout__sub-knob"></span>
            </span>
            <span class="dh-cart-checkout__sub-label">Subscription · <em>${intervalText}</em></span>
          </label>` : '';

        return `
          <article class="dh-cart-checkout__product-card dh-cart-checkout__secondary-card" data-secondary-key="${item.key}">
            <div class="dh-cart-checkout__thumb-wrap">${imageMarkup}</div>
            <div class="dh-cart-checkout__secondary-copy">
              <h4>${escapedTitle}</h4>
              <div class="dh-cart-checkout__secondary-meta">
                ${compareLineMarkup}
                <span class="dh-cart-checkout__secondary-price">${linePrice}</span>
                ${saveMarkup}
              </div>
            </div>
            <div class="dh-cart-checkout__actions dh-cart-checkout__secondary-actions">
              <button type="button" class="dh-cart-checkout__remove dh-cart-checkout__secondary-remove" data-remove-secondary="${item.key}" aria-label="Remove added product">
                <span aria-hidden="true">&#128465;</span>
              </button>
              <div class="dh-cart-checkout__qty" aria-label="Quantity">
                <button type="button" class="is-minus" data-secondary-decrease="${item.key}" aria-label="Decrease" ${quantity <= 1 ? 'disabled aria-disabled="true"' : ''}>-</button>
                <output>${quantity}</output>
                <button type="button" class="is-plus" data-secondary-increase="${item.key}" aria-label="Increase">+</button>
              </div>
            </div>
            <div class="dh-cart-checkout__secondary-loader-wrap" data-secondary-loader="${item.key}" hidden aria-hidden="true">
              <div class="dh-cart-checkout__secondary-loader"></div>
            </div>
            ${subToggleMarkup}
          </article>
        `;
      }).join('');
    };

    const syncItemsScrollIndicator = () => {
      if (!itemsScrollNode) return;

      const canScroll = secondaryCartItems.length > 0 && itemsScrollNode.scrollHeight > itemsScrollNode.clientHeight + 2;
      root.classList.toggle('has-scrollable-items', canScroll);

      if (!canScroll) {
        if (itemsScrollThumb) {
          itemsScrollThumb.style.height = '52px';
          itemsScrollThumb.style.transform = 'translateY(0)';
        }
        return;
      }

      const trackInset = 8;
      const trackHeight = Math.max(74, itemsScrollNode.clientHeight - trackInset * 2);
      const naturalThumbHeight = Math.round((itemsScrollNode.clientHeight / itemsScrollNode.scrollHeight) * trackHeight);
      const thumbHeight = Math.max(34, Math.min(58, naturalThumbHeight));
      const travel = Math.max(36, trackHeight - thumbHeight);
      const maxScrollTop = Math.max(1, itemsScrollNode.scrollHeight - itemsScrollNode.clientHeight);
      const thumbTop = trackInset + Math.round((itemsScrollNode.scrollTop / maxScrollTop) * travel);

      if (itemsScrollThumb) {
        itemsScrollThumb.style.height = `${thumbHeight}px`;
        itemsScrollThumb.style.transform = `translateY(${thumbTop}px)`;
      }
    };

    const fetchAndCacheSecondaryPlanIds = async (items) => {
      const itemsToFetch = items.filter((item) => {
        const vid = Number(item.variant_id || 0);
        if (!vid) return false;
        if (item.selling_plan_allocation) return false;
        const planInfo = upsellPlanMap[vid];
        if (planInfo && planInfo.planId) return false;
        if (secondarySubPlanCache[vid] && secondarySubPlanCache[vid].planId) return false;
        return true;
      });
      if (!itemsToFetch.length) return;
      // Handles unicos a pedir en esta pasada - se marcan como "ya pedidos" antes de disparar los
      // fetches (no despues, como en el loop secuencial anterior) para que dos items con el mismo
      // handle no disparen el mismo fetch dos veces al correr en paralelo.
      const handlesToFetch = [];
      for (const item of itemsToFetch) {
        const handle = item.handle || (item.url && item.url.match(/\/products\/([^/?#]+)/)?.[1]);
        if (!handle || secondaryFetchedHandles.has(handle)) continue;
        secondaryFetchedHandles.add(handle);
        handlesToFetch.push(handle);
      }
      if (!handlesToFetch.length) return;
      // Se piden todos los productos en paralelo en vez de uno por uno (for...of secuencial) -
      // con varios upsells en el drawer, el loop secuencial sumaba una llamada de red detras de
      // otra y era una de las causas principales de que el drawer tardara en abrir (confirmado
      // 2026-09-14).
      await Promise.all(handlesToFetch.map(async (handle) => {
        try {
          const resp = await fetch(`${Shopify.routes.root}products/${handle}.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!resp.ok) return;
          const product = await resp.json();
          const groups = product.selling_plan_groups;
          if (!Array.isArray(groups) || !groups.length) return;
          const firstPlan = groups[0].selling_plans && groups[0].selling_plans[0];
          if (!firstPlan) return;
          const planId = Number(firstPlan.id) || 0;
          const planName = firstPlan.name || '';
          if (!planId) return;
          (product.variants || []).forEach((v) => {
            const vid = Number(v.id);
            if (vid && !(secondarySubPlanCache[vid] && secondarySubPlanCache[vid].planId)) {
              secondarySubPlanCache[vid] = { planId, name: planName };
            }
          });
        } catch (e) {}
      }));
    };

    const updateSecondaryProductsFromCart = async (cart = null, { animateProgress = true, forceProgressAnimation = false } = {}) => {
      const cartData = cart || await (await fetch(`${Shopify.routes.root}cart.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
      syncCartCountBadge(Number(cartData.item_count) || 0);
      const hadSecondaryItems = secondaryCartItems.length > 0;

      const primaryVariantId = getPrimaryVariantId();
      const primaryLineItem = primaryVariantId && Array.isArray(cartData.items)
        ? cartData.items.find((item) => Number(item.variant_id || 0) === primaryVariantId)
        : null;
      const newPrimaryInCart = !!primaryLineItem;

      if (newPrimaryInCart && (!primaryInCart || primaryRemoved)) {
        primaryRemoved = false;
        // El producto vuelve a entrar al carrito desde cero: lo que decida a partir de aca manda
        // el carrito (el bloque de abajo lee su selling_plan_allocation), no una eleccion previa
        // del toggle que correspondia a lo que habia antes.
        subscriptionUserOverride = false;
        qty = Number((primaryLineItem && primaryLineItem.quantity) || 1) || 1;
        // If section settings don't have sub price but cart item has a selling plan, read from cart
        if (primaryLineItem.selling_plan_allocation && !subPriceCents && subToggleWrap) {
          const spAlloc = primaryLineItem.selling_plan_allocation;
          const cartSubPrice = Number(spAlloc.price) || 0;
          const planName = (spAlloc.selling_plan && spAlloc.selling_plan.name) || '';
          if (cartSubPrice > 0) {
            effectiveSubPriceCents = cartSubPrice;
            subToggleWrap.hidden = false;
            subscriptionActive = true;
            if (subToggleCheckbox) subToggleCheckbox.checked = true;
            const intervalNode = root.querySelector('[data-sub-interval-text]');
            if (intervalNode && planName) intervalNode.textContent = formatSellingPlanName(planName);
            primaryPricingState = { ...primaryPricingState, finalCents: cartSubPrice };
          }
        }
      }
      if (newPrimaryInCart && primaryLineItem) {
        const cartItemImage = normalizeImageSrc(primaryLineItem.image) || normalizeImageSrc(primaryLineItem.featured_image);
        if (cartItemImage && primaryThumbNode) {
          primaryThumbNode.src = cartItemImage;
          primaryThumbNode.setAttribute('src', cartItemImage);
          primaryPricingState = { ...primaryPricingState, imageSrc: cartItemImage };
        }
      }
      primaryInCart = newPrimaryInCart;

      // El texto del intervalo ("Cada mes", "Cada 3 meses", etc.) viene directo de
      // selling_plan_allocation.selling_plan.name de la linea real del carrito (/cart.js) - no
      // depende para nada del widget de Kaching, asi que NO se debe condicionar a
      // isKachingBundlesPage(). Kaching es un script de terceros que carga de forma asincrona y
      // puede tardar en inyectar su markup (ej. al volver de checkout con el boton atras) -
      // ponerlo adentro del bloque de Kaching hacia que a veces no corriera y el intervalo se
      // quedara pegado en el valor viejo aunque el precio ya estuviera bien (confirmado
      // 2026-09-14: mostraba "Cada mes" con qty=3 hasta recargar la pagina).
      if (newPrimaryInCart && primaryLineItem && primaryLineItem.selling_plan_allocation) {
        const spAllocForInterval = primaryLineItem.selling_plan_allocation;
        const intervalNodeFromLine = root.querySelector('[data-sub-interval-text]');
        if (intervalNodeFromLine && spAllocForInterval.selling_plan) {
          const intervalText = getSellingPlanIntervalText(spAllocForInterval.selling_plan);
          if (intervalText) intervalNodeFromLine.textContent = intervalText;
        }
      } else if (subPlanId > 0) {
        // La linea es de una vez (o el producto todavia no esta en el carrito): no hay
        // selling_plan_allocation real de donde leer el intervalo. El texto NO puede quedarse en
        // subPlanId/data-sub-interval (fijos desde el Liquid al cargar la pagina, siempre el plan
        // de la variante por defecto) porque en bundles "quantity-break" cada barra puede agregar
        // una VARIANTE distinta con su propio selling plan (ver nota en
        // fetchPrimarySubscriptionInfoForVariant). Se resuelve el plan a partir de la variante que
        // ya esta (o va a estar) en el carrito, no del input del formulario.
        const intervalNodeFromVariant = root.querySelector('[data-sub-interval-text]');
        if (intervalNodeFromVariant) {
          const variantForInterval = (newPrimaryInCart && primaryLineItem)
            ? Number(primaryLineItem.variant_id || 0)
            : getPrimaryVariantId();
          const subInfo = await fetchPrimarySubscriptionInfoForVariant(variantForInterval);
          if (subInfo && subInfo.name) intervalNodeFromVariant.textContent = subInfo.name;
        }
      }

      if (newPrimaryInCart && primaryLineItem && primaryLineItem.selling_plan_allocation && !isKachingBundlesPage()) {
        const cartFinalCents = Number(primaryLineItem.final_price || 0);
        const spCompare = Number(primaryLineItem.selling_plan_allocation.compare_at_price || 0);
        if (spCompare > 0) {
          nonKachingCompareCents = spCompare;
          if (spCompare > cartFinalCents && spCompare > (primaryPricingState.compareCents || 0)) {
            primaryPricingState = { ...primaryPricingState, compareCents: spCompare };
          }
        }
      }

      if (newPrimaryInCart && primaryLineItem && isKachingBundlesPage()) {
        const cartQty = Number(primaryLineItem.quantity || 1);
        const cartFinalPrice = Number(primaryLineItem.final_price || 0);
        const cartOriginalLinePrice = Number(primaryLineItem.original_line_price || 0);
        const cartComparePerUnit = cartOriginalLinePrice > 0
          ? Math.round(cartOriginalLinePrice / cartQty)
          : Number(primaryLineItem.compare_at_price || 0);
        const hasSellingPlan = !!(primaryLineItem.selling_plan_allocation);
        if (cartFinalPrice > 0) {
          qty = cartQty;
          kachingPerUnitCache.detected = true;
          if (hasSellingPlan) {
            // cartFinalPrice aca es el precio con selling_plan aplicado por Shopify sobre el
            // precio REGULAR, sin el descuento de bundle de Kaching - por eso NO se usa como
            // precio de suscripcion salvo que fallen tanto el scrape del DOM como el calculo por
            // porcentaje de abajo.
            // Los precios que Kaching muestra en sus bars son el TOTAL del bundle (ej. $79.98
            // para "Compra 2 + 1 Gratis" = 3 unidades), no el precio por unidad - hay que dividir
            // por cartQty antes de guardarlos en kachingPerUnitCache, que sync() vuelve a
            // multiplicar por qty (confirmado 2026-07-27: sin dividir, $79.98 x 3 = $239.94).
            // Estamos en la rama hasSellingPlan: la linea SI tiene selling_plan_allocation, o sea
            // que el widget estaba en modo suscripcion al agregar. Por lo tanto el precio que
            // muestra la barra de cantidad es, por definicion, el de SUSCRIPCION - y el de una vez
            // NO esta en el DOM, hay que calcularlo con fetchKachingOneTimePricePerUnit().
            // Antes esto se decidia mirando que card tenia --selected, deteccion que se invierte
            // con subscribeByDefault (ver nota larga arriba): el precio de suscripcion se tomaba
            // como precio de una vez y despues se le restaba el % del plan OTRA vez, dando el
            // doble descuento ($61.32 en vez de $69.33 en la barra 2+1 de Apple Cider).
            const scrapedSubOnAdd = getSelectedQuantityBarPriceCents();
            const spAlloc = primaryLineItem.selling_plan_allocation;
            const spCompare = Number(spAlloc && spAlloc.compare_at_price || 0);
            // spCompare es el compare_at_price de la propia linea real del carrito - siempre
            // corresponde a la variante que efectivamente esta en el carrito. unitCents es un
            // valor fijo (variante por defecto de la pagina al cargar) que en bundles con una
            // variante distinta por barra (ver fetchPrimarySubscriptionInfoForVariant) NO
            // corresponde a la variante actual - priorizarlo aca causaba el mismo tipo de bug que
            // el intervalo (ej. $89 de la variante "1" en vez de $178 de la variante "2" para
            // Slim Boost "Compra 2 + 1 Gratis", confirmado 2026-09-25).
            const baseUnitCents = spCompare || unitCents;

            // El precio "con suscripcion" SI se puede leer del DOM con confianza: es lo que
            // Kaching ya renderizo en la barra de cantidad seleccionada mientras su propio widget
            // de suscripcion en la pagina estaba activo (el estado en que se agrego este item).
            kachingPerUnitCache.withSub = scrapedSubOnAdd > 0
              ? Math.round(scrapedSubOnAdd / cartQty)
              : cartFinalPrice;

            // El precio "de una vez" (oneTime) NO se puede leer del DOM en este estado (el bar
            // solo muestra uno de los dos precios a la vez) NI calcular con
            // fetchKachingOneTimePricePerUnit(): esa funcion busca en TODAS las ofertas de la
            // tienda (fetchDeals() no expone a que producto pertenece cada una, ver nota en
            // fetchPrimarySubscriptionInfoForVariant) y devuelve la primera con la MISMA
            // CANTIDAD, sin importar el producto - confirmado 2026-09-25 en Slim Boost: devolvia
            // el 33% de descuento de Apple Cider/Berberine (misma cantidad=3, oferta distinta) en
            // vez del descuento real de Slim Boost, dando $357.78 en vez de $178.00. En cambio, se
            // DESPEJA el precio de una vez a partir del precio con suscripcion YA correcto (de
            // arriba, confiable) y el % del selling plan de la VARIANTE real (si
            // precio_con_suscripcion = precio_de_una_vez x (1 - %plan), entonces
            // precio_de_una_vez = precio_con_suscripcion / (1 - %plan)) - mismo criterio ya
            // documentado para el sentido inverso en la rama sin selling plan, mas abajo.
            let planPct = getSellingPlanAdjustmentPct(spAlloc);
            if (planPct <= 0) {
              const subInfo = await fetchPrimarySubscriptionInfoForVariant(Number(primaryLineItem.variant_id || 0));
              if (subInfo) planPct = subInfo.adjustmentPct;
            }
            if (planPct > 0 && planPct < 100 && kachingPerUnitCache.withSub > 0) {
              kachingPerUnitCache.oneTime = Math.round(kachingPerUnitCache.withSub / (1 - planPct / 100));
            } else {
              // Ultimo recurso si no se pudo determinar el % real del plan: la funcion vieja
              // (con el riesgo de cruzarse de producto documentado arriba) o el precio base sin
              // descontar de la variante.
              const fallbackOneTime = await fetchKachingOneTimePricePerUnit(cartQty, baseUnitCents);
              kachingPerUnitCache.oneTime = fallbackOneTime > 0 ? fallbackOneTime : baseUnitCents;
            }

            // Red de seguridad: un precio "con suscripcion" nunca puede ser igual o mayor al de
            // una vez (dejaria de ser un descuento).
            if (kachingPerUnitCache.oneTime <= kachingPerUnitCache.withSub) {
              kachingPerUnitCache.oneTime = Math.max(baseUnitCents, kachingPerUnitCache.withSub);
            }
            // El texto del intervalo ya se sincroniza mas arriba (fuera del if de Kaching), sin
            // depender de isKachingBundlesPage() - ver el bloque justo despues de
            // "primaryInCart = newPrimaryInCart".
          } else {
            // getSelectedQuantityBarPriceCents() lee el precio directo del DOM del widget de
            // Kaching en la pagina (el bar actualmente seleccionado) - es la fuente mas confiable
            // porque es lo que Kaching YA renderizo, sin depender de ningun fetch. El fetch a
            // fetchDeals() queda como respaldo para cuando el widget no esta en el DOM (ej. si el
            // fetch corre antes de que Kaching termine de inicializar justo despues de un
            // "Agregar al carrito" - confirmado 2026-07-27: en ese momento kachingBundlesApi
            // todavia no existe, el fetch devuelve 0, y sin este respaldo se caia al precio
            // crudo del carrito ($135 en vez de $90.45).
            const baseUnitCents = cartFinalPrice || unitCents || cartComparePerUnit;
            // Los precios que Kaching muestra en sus bars son el TOTAL del bundle, no el precio
            // por unidad - hay que dividir por cartQty (sync() vuelve a multiplicar por qty).
            // Sin selling plan en la linea: el widget estaba en modo "una vez" al agregar, asi que
            // el precio del bar ES el de una vez y se puede leer directo (sin pasar por la
            // deteccion por posicion, que ademas devolvia 0 en Apple Cider por la inversion).
            const scrapedOneTimeRaw = getSelectedQuantityBarPriceCents();
            const scrapedOneTime = scrapedOneTimeRaw > 0 ? Math.round(scrapedOneTimeRaw / cartQty) : 0;
            const oneTimePerUnit = scrapedOneTime > 0 ? scrapedOneTime : await fetchKachingOneTimePricePerUnit(cartQty, baseUnitCents);
            kachingPerUnitCache.oneTime = oneTimePerUnit > 0 ? oneTimePerUnit : cartFinalPrice;
            // Se pinta el precio one-time YA (no hace falta esperar el calculo de suscripcion,
            // que depende de un fetch que puede tardar varios segundos) para que el drawer no se
            // quede mostrando el precio viejo mientras tanto.
            primaryPricingState = {
              ...primaryPricingState,
              finalCents: kachingPerUnitCache.oneTime,
              compareCents: cartComparePerUnit > cartFinalPrice ? cartComparePerUnit : primaryPricingState.compareCents
            };
            sync();
            // El precio con suscripcion NO se puede scrapear en esta rama: como la linea no tiene
            // selling plan, el bar esta mostrando el precio de una vez, no el de suscripcion (ese
            // nodo muestra uno u otro, nunca los dos). Se calcula siempre con el % del selling plan
            // sobre el precio de bundle YA con descuento (no con alloc.price de Shopify - ver nota
            // historica: eso daba $119.37 en vez de $79.98 para la barra 2).
            // fetchPrimarySellingPlanInfo(cartQty) adivinaba el plan igualando "meses en el
            // nombre" a la cantidad comprada (valido solo si 1 unidad = 1 mes) - se resuelve por
            // la variante real de la linea en su lugar (confirmado 2026-09-25: en Slim Boost
            // "Compra 2 + 1 Gratis" devolvia el plan de 2 meses/15% en vez del de 6 meses/10%,
            // pisando el texto de intervalo correcto que ya se habia calculado mas arriba y dando
            // un precio de suscripcion incorrecto al togglear).
            const subInfo = await fetchPrimarySubscriptionInfoForVariant(Number(primaryLineItem.variant_id || 0));
            if (subInfo && subInfo.adjustmentPct > 0 && kachingPerUnitCache.oneTime > 0) {
              kachingPerUnitCache.withSub = Math.round(kachingPerUnitCache.oneTime * (1 - subInfo.adjustmentPct / 100));
              effectiveSubPriceCents = kachingPerUnitCache.withSub;
            }
            if (subInfo && subInfo.name && subToggleWrap) {
              const intervalNode = root.querySelector('[data-sub-interval-text]');
              if (intervalNode) intervalNode.textContent = formatSellingPlanName(subInfo.name);
            }
          }
          // hasSellingPlan refleja el plan que HOY tiene la linea en el carrito real, pero si el
          // cliente ya toco el toggle del drawer (subscriptionUserOverride) hay que mostrar el
          // precio de esa eleccion, no la del carrito - syncPrimaryProductForCheckout() se encarga
          // de que el carrito real termine coincidiendo antes de ir a checkout.
          const showSubscriptionPrice = subscriptionUserOverride ? subscriptionActive : hasSellingPlan;
          primaryPricingState = {
            ...primaryPricingState,
            finalCents: showSubscriptionPrice ? (kachingPerUnitCache.withSub || cartFinalPrice) : kachingPerUnitCache.oneTime,
            compareCents: cartComparePerUnit > cartFinalPrice ? cartComparePerUnit : primaryPricingState.compareCents
          };
        }
      }

      if (subToggleWrap) await initSubscriptionToggle();

      // initSubscriptionToggle() deriva subscriptionActive de getPrimarySellingPlanId(), que lee
      // el <input name="selling_plan"> del FORMULARIO de la pagina en ese instante - no del
      // carrito real. Si el widget de Kaching todavia no habia marcado ese input como
      // seleccionado (ej. justo despues de agregar, o en un reload antes de que Kaching reaplique
      // la seleccion), el toggle quedaba apagado aunque la linea real del carrito SI tuviera la
      // suscripcion activa (confirmado 2026-09-14 con Gut Boost Pro, variante "2 Pack" - el
      // payload de /cart/add.js llevaba el selling_plan correcto, pero el toggle del drawer
      // igual aparecia apagado). Se corrige aca, DESPUES de initSubscriptionToggle(), para que la
      // verdad del carrito tenga la ultima palabra - salvo que el cliente ya haya tocado el
      // toggle a mano en este mismo drawer (subscriptionUserOverride), eleccion que no se pisa.
      if (newPrimaryInCart && primaryLineItem && !subscriptionUserOverride) {
        const hasRealSubscription = !!primaryLineItem.selling_plan_allocation;
        subscriptionActive = hasRealSubscription;
        if (subToggleCheckbox) subToggleCheckbox.checked = subscriptionActive;
        if (subToggleWrap && hasRealSubscription) subToggleWrap.hidden = false;
        // initSubscriptionToggle() (arriba) ya recalculo primaryPricingState.finalCents, pero
        // usando el subscriptionActive de ANTES de esta correccion (todavia en false en un
        // reload) - as apenas se leyera, quedaba el toggle encendido pero el precio pintado
        // era el de una vez (confirmado 2026-09-14 con Gut Boost Pro: $49.80 en vez de $42.34
        // hasta tocar el toggle a mano). Se recalcula con el subscriptionActive ya corregido,
        // usando primaryLineItem.final_price directo - es el precio real que Shopify aplico,
        // sin depender de kachingPerUnitCache.
        const realFinalCents = Number(primaryLineItem.final_price || 0);
        if (hasRealSubscription && realFinalCents > 0) {
          primaryPricingState = { ...primaryPricingState, finalCents: realFinalCents };
        } else if (!hasRealSubscription && kachingPerUnitCache.detected && kachingPerUnitCache.oneTime > 0) {
          primaryPricingState = { ...primaryPricingState, finalCents: kachingPerUnitCache.oneTime };
        }
      }

      secondaryCartItems = Array.isArray(cartData.items) ? cartData.items.filter((item) => !isPrimaryCartItem(item)) : [];
      secondaryCartItems.forEach((item) => {
        const vid = Number(item.variant_id || 0);
        if (vid && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
          secondarySubPlanCache[vid] = {
            planId: Number(item.selling_plan_allocation.selling_plan.id) || 0,
            name: item.selling_plan_allocation.selling_plan.name || ''
          };
        }
      });
      await fetchAndCacheSecondaryPlanIds(secondaryCartItems);
      renderSecondaryProducts();
      sync();
      requestAnimationFrame(syncItemsScrollIndicator);
      updateProgressLockState(shouldUnlockProgress(), {
        animate: animateProgress && root.classList.contains('is-open') && (forceProgressAnimation || (!hadSecondaryItems && secondaryCartItems.length > 0))
      });
      return cartData;
    };

    const removeSecondaryProduct = async (lineKey) => {
      if (!lineKey) return;
      const response = await fetch(`${Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0
        })
      });
      const cartData = await response.json();
      if (!response.ok) {
        throw new Error(cartData && cartData.description ? cartData.description : 'Could not remove the product');
      }
      await updateSecondaryProductsFromCart(cartData);
    };

    const toggleSecondarySubscription = async (lineKey, variantId, quantity, activateSub) => {
      window._dhSuppressCartOpen = true;
      try {
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: lineKey, quantity: 0 })
        });
        const planInfo = upsellPlanMap[variantId];
        const effectivePlanId = (planInfo && planInfo.planId) || (secondarySubPlanCache[variantId] && secondarySubPlanCache[variantId].planId) || 0;
        const addBody = { id: variantId, quantity: Number(quantity || 1) || 1 };
        if (activateSub && effectivePlanId) addBody.selling_plan = effectivePlanId;
        await fetch(`${Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(addBody)
        });
        const cartData = await (await fetch(`${Shopify.routes.root}cart.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
        await updateSecondaryProductsFromCart(cartData);
      } finally {
        window._dhSuppressCartOpen = false;
      }
    };

    const syncPrimaryProductForCheckout = async () => {
      if (primaryRemoved) return;

      const variantId = getPrimaryVariantId();
      if (!variantId) return;

      // subPlanId es un valor fijo (capturado del Liquid al cargar la pagina, siempre el plan de
      // la variante por defecto). En bundles "quantity-break" cada barra puede agregar una
      // VARIANTE distinta con su propio selling plan (ej. Slim Boost: "Compra 1" = variante de 2
      // meses, "Compra 2 + 1 Gratis" = variante de 6 meses) - usar subPlanId fijo mandaba siempre
      // el plan de 2 meses sin importar la barra elegida, y el input[name="selling_plan"] del
      // formulario tampoco sirve como reemplazo porque Kaching solo lo llena cuando su widget de
      // suscripcion EN LA PAGINA esta activo (ver fetchPrimarySubscriptionInfoForVariant). Se
      // resuelve el plan de la variante que realmente se va a agregar (variantId, ya calculado
      // arriba); subPlanId queda de ultimo fallback si esa variante no tiene ningun plan propio.
      let sellingPlanId = 0;
      if (subPlanId > 0) {
        if (subscriptionActive) {
          const subInfo = await fetchPrimarySubscriptionInfoForVariant(variantId);
          sellingPlanId = (subInfo && subInfo.planId) || subPlanId;
        }
      } else {
        sellingPlanId = getPrimarySellingPlanId();
      }
      const cart = await (await cartFetch(`${Shopify.routes.root}cart.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
      const matchingLine = Array.isArray(cart.items)
        ? cart.items.find((item) => Number(item.variant_id || 0) === variantId)
        : null;
      const currentPlanId = (matchingLine && matchingLine.selling_plan_allocation && matchingLine.selling_plan_allocation.selling_plan)
        ? Number(matchingLine.selling_plan_allocation.selling_plan.id) || 0
        : 0;
      const planChanged = currentPlanId !== sellingPlanId;

      if (matchingLine && !planChanged && Number(matchingLine.quantity || 0) === qty) {
        return;
      }

      // cart/change.js solo puede tocar cantidad, no el selling_plan de una linea existente.
      // Si el toggle de suscripcion del drawer cambio el plan deseado, hay que sacar la linea
      // vieja (quantity: 0) y volver a agregarla con el plan correcto - mismo patron que
      // toggleSecondarySubscription() usa para los productos secundarios. Usa cartFetch (el fetch
      // nativo, no el window.fetch actual) para que Kaching no intercepte este cambio de plan.
      if (matchingLine) {
        await cartFetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: matchingLine.key,
            quantity: planChanged ? 0 : qty
          })
        });
        if (!planChanged) return;
      }

      const payload = {
        id: variantId,
        quantity: qty
      };

      if (sellingPlanId) {
        payload.selling_plan = sellingPlanId;
      }

      await cartFetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      });
    };

    // El contador cuenta desde que carga la pagina. Antes restaba 100 ms por cada tick de un
    // setInterval que corria SIEMPRE (con el drawer cerrado y la pestana oculta). Ahora el tick
    // solo corre con el drawer abierto y la pestana visible, asi que el tiempo restante se
    // calcula contra una hora de fin fija: al reabrir muestra el valor correcto en vez de
    // haberse quedado congelado, y ya no depende de que el intervalo dispare cada 100 ms.
    const countdownEndsAt = Date.now() + timeLeftMs;
    let countdownTimer = null;
    let drawerIsOpen = false;

    const tick = () => {
      if (!countdownNode) return;
      timeLeftMs = Math.max(0, countdownEndsAt - Date.now());
      const totalSeconds = Math.floor(timeLeftMs / 1000);
      const mm = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
      const ss = (totalSeconds % 60).toString().padStart(2, '0');
      const cs = Math.floor((timeLeftMs % 1000) / 10).toString().padStart(2, '0');
      countdownNode.textContent = mm + ':' + ss + '.' + cs;
      if (timeLeftMs <= 0) stopCountdown();
    };

    const stopCountdown = () => {
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    };

    const startCountdown = () => {
      if (countdownTimer || !countdownNode || !drawerIsOpen || document.hidden) return;
      tick();
      if (timeLeftMs > 0) countdownTimer = setInterval(tick, 100);
    };

    const lockBackgroundScroll = () => {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.body.classList.add('dh-cart-checkout-no-scroll');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    };

    const unlockBackgroundScroll = () => {
      document.body.classList.remove('dh-cart-checkout-no-scroll');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
    };

    const openDrawer = () => {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      drawerIsOpen = true;
      root.hidden = false;
      if (overlay) overlay.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      lockBackgroundScroll();
      requestAnimationFrame(() => {
        root.classList.add('is-open');
        if (overlay) overlay.classList.add('is-open');
      });
      primaryPricingState = capturePrimaryPricingState();
      // NO se llama initSubscriptionToggle() aca de forma prematura (antes se llamaba dos veces:
      // aca y al final de updateSecondaryProductsFromCart). En esta primera llamada "qty" todavia
      // vale el default (1, no la cantidad real del carrito), asi que su fallback de fetch
      // (initSubscriptionToggle -> fetchPrimarySellingPlanInfo(qty)) pedia el plan de 1 mes y a
      // veces resolvia DESPUES de que updateSecondaryProductsFromCart ya hubiera puesto el
      // intervalo correcto (ej. "Cada 3 meses"), pisandolo con el de 1 mes - condicion de carrera
      // confirmada 2026-09-14 con Colon Gentle Cleanse (intermitente: a veces ganaba el dato
      // correcto, a veces el viejo). updateSecondaryProductsFromCart ya llama a
      // initSubscriptionToggle() al final, con la cantidad y el intervalo reales ya resueltos.
      sync();
      updateSecondaryProductsFromCart(null, { animateProgress: true, forceProgressAnimation: shouldUnlockProgress() }).catch((error) => console.error('[DH Cart Checkout] Error cargando productos agregados', error));
      // Se saca del hilo sincronico del click: aunque ya esta batcheado en un solo reflow (ver
      // comentario en syncFeaturedTrackHeight), sigue siendo un reflow forzado - correrlo aca lo
      // metia en el mismo frame que root.classList.add('is-open') de arriba, compitiendo por el
      // frame en el que el navegador recien va a empezar a animar el transform de apertura. Un
      // rAF lo empuja al frame siguiente, despues de que la transicion ya arranco.
      requestAnimationFrame(syncFeaturedTrackHeight);
      startFeaturedAutoplay();
      startCountdown();
    };

    const closeDrawer = () => {
      drawerIsOpen = false;
      stopFeaturedAutoplay();
      stopCountdown();
      root.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      unlockBackgroundScroll();
      root.classList.remove('is-animating', 'is-filled', 'is-progress-locked');
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        root.hidden = true;
        if (overlay) overlay.hidden = true;
        closeTimer = null;
      }, 380);
    };

    root.querySelector('[data-increase]')?.addEventListener('click', () => {
      qty += 1;
      sync();
    });

    root.querySelector('[data-decrease]')?.addEventListener('click', () => {
      if (qty > 1) {
        qty -= 1;
        sync();
      }
    });

    removePrimaryBtn?.addEventListener('click', async () => {
      primaryRemoved = true;
      primaryInCart = false;
      qty = 1;
      // La eleccion de suscripcion pertenece al producto que se acaba de sacar del carrito: si no
      // se reinicia, el proximo producto que se agregue heredaria ese "si" (confirmado 2026-07-27:
      // se agregaba con suscripcion aunque se hubiera elegido sin ella).
      subscriptionUserOverride = false;
      subscriptionActive = false;
      if (subToggleCheckbox) subToggleCheckbox.checked = false;
      sync();
      updateProgressLockState(shouldUnlockProgress());

      const variantId = getPrimaryVariantId();
      if (!variantId) return;
      try {
        const cartData = await (await fetch(`${Shopify.routes.root}cart.js`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })).json();
        const line = Array.isArray(cartData.items) ? cartData.items.find((item) => Number(item.variant_id || 0) === variantId) : null;
        if (line) {
          const changeRes = await fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          });
          const updatedCart = changeRes.ok ? await changeRes.json() : null;
          if (updatedCart) syncCartCountBadge(Number(updatedCart.item_count) || 0);
        }
      } catch (e) {
        console.error('[DH Cart Checkout] Error eliminando producto del carrito', e);
      }
    });

    root.querySelector('[data-apply-coupon]')?.addEventListener('click', syncCoupon);

    couponToggleBtn?.addEventListener('click', () => {
      const willOpen = couponPanel.hidden;
      couponPanel.hidden = !willOpen;
      couponToggleBtn.classList.toggle('is-open', willOpen);
    });

    subToggleCheckbox?.addEventListener('change', () => {
      subscriptionActive = subToggleCheckbox.checked;
      subscriptionUserOverride = true;
      let finalCents;
      if ((isKachingBundlesPage() || kachingPerUnitCache.detected) && (kachingPerUnitCache.oneTime > 0 || kachingPerUnitCache.withSub > 0)) {
        finalCents = subscriptionActive && effectiveSubPriceCents > 0
          ? (kachingPerUnitCache.withSub || effectiveSubPriceCents)
          : (kachingPerUnitCache.oneTime || unitCents);
      } else {
        const baseCents = getBasePricingFromProductPage().finalCents || nonKachingCompareCents || unitCents;
        finalCents = subscriptionActive && effectiveSubPriceCents > 0 ? effectiveSubPriceCents : baseCents;
      }
      primaryPricingState = {
        ...primaryPricingState,
        finalCents
      };
      sync();

      // NO sincronizar el carrito real aca (se probo y se revirtio - ver nota larga mas abajo).
      // Solo se muestra el estimado local; syncPrimaryProductForCheckout() sigue corriendo una
      // sola vez, justo antes de ir a pagar (ver listener de checkoutLink), que es el momento en
      // que este mecanismo SI es confiable.
      //
      // Historia (2026-09-25): se probo escribir al carrito real en cada toggle (mismo mecanismo
      // que ya corria al pagar) para no depender de este estimado. Confirmado en vivo que el
      // cambio SI llegaba a Shopify (verificado con fetch nativo, sin pasar por Kaching) pero
      // volvia solo al precio de una vez segundos despues - algo (muy probablemente Kaching,
      // reaccionando a un cambio de carrito que su propio widget en la pagina nunca disparo)
      // deshacia el plan de suscripcion por su cuenta. Escribir al carrito recien al ir a pagar
      // (como ya hacia este archivo antes de esa prueba) no deja tiempo para que eso pase, porque
      // el navegador redirige a /checkout enseguida despues.
    });

    featuredDots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goToFeaturedSlide(Number(dot.dataset.index || 0) || 0);
        startFeaturedAutoplay();
      });
    });

    featuredTrack?.addEventListener('mouseenter', stopFeaturedAutoplay);
    featuredTrack?.addEventListener('mouseleave', startFeaturedAutoplay);
    featuredTrack?.addEventListener('focusin', stopFeaturedAutoplay);
    featuredTrack?.addEventListener('focusout', () => {
      if (!featuredTrack.contains(document.activeElement)) {
        startFeaturedAutoplay();
      }
    });

    featuredTrack?.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchDeltaX = 0;
      isTouchTracking = true;
      stopFeaturedAutoplay();
    }, { passive: true });

    featuredTrack?.addEventListener('touchmove', (event) => {
      if (!isTouchTracking || event.touches.length !== 1) return;
      const touch = event.touches[0];
      touchDeltaX = touch.clientX - touchStartX;
      const touchDeltaY = touch.clientY - touchStartY;

      if (Math.abs(touchDeltaY) > Math.abs(touchDeltaX)) {
        isTouchTracking = false;
      }
    }, { passive: true });

    featuredTrack?.addEventListener('touchend', () => {
      if (!isTouchTracking) {
        startFeaturedAutoplay();
        return;
      }

      const swipeThreshold = 42;

      if (Math.abs(touchDeltaX) >= swipeThreshold) {
        if (touchDeltaX < 0) {
          goToFeaturedSlide(featuredIndex + 1);
        } else {
          goToFeaturedSlide(featuredIndex - 1);
        }
      }

      isTouchTracking = false;
      touchDeltaX = 0;
      startFeaturedAutoplay();
    });

    featuredTrack?.addEventListener('touchcancel', () => {
      isTouchTracking = false;
      touchDeltaX = 0;
      startFeaturedAutoplay();
    });

    itemsScrollNode?.addEventListener('scroll', syncItemsScrollIndicator, { passive: true });

    window.addEventListener('resize', () => {
      syncFeaturedTrackHeight();
      syncItemsScrollIndicator();
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopFeaturedAutoplay();
        stopCountdown();
      } else if (!root.hidden) {
        startFeaturedAutoplay();
        startCountdown();
      }
    });

    launcher?.addEventListener('click', (event) => {
      event.preventDefault();
      openDrawer();
    });


    closeBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      closeDrawer();
    });

    overlay?.addEventListener('click', closeDrawer);

    secondaryProductsNode?.addEventListener('click', async (event) => {
      const subToggleLabel = event.target.closest('[data-secondary-sub-toggle]');
      if (subToggleLabel) {
        event.preventDefault();
        const lineKey = subToggleLabel.dataset.secondarySubToggle;
        const variantId = Number(subToggleLabel.dataset.variantId || 0);
        const targetItem = secondaryCartItems.find((i) => i.key === lineKey);
        if (!targetItem || !variantId) return;
        const activateSub = !(targetItem.selling_plan_allocation && targetItem.selling_plan_allocation.selling_plan);
        const checkbox = subToggleLabel.querySelector('.dh-cart-checkout__sub-checkbox');
        const secondaryCard = subToggleLabel.closest('.dh-cart-checkout__secondary-card');
        const loader = secondaryCard ? secondaryCard.querySelector(`[data-secondary-loader="${lineKey}"]`) : null;
        if (checkbox) checkbox.checked = activateSub;
        if (secondaryCard) secondaryCard.classList.add('is-secondary-loading');
        if (loader) loader.hidden = false;
        subToggleLabel.style.pointerEvents = 'none';
        subToggleLabel.style.opacity = '0.35';
        try {
          await toggleSecondarySubscription(lineKey, variantId, targetItem.quantity, activateSub);
        } catch (err) {
          console.error('[DH Cart Checkout] Error toggling suscripción secundaria', err);
          if (checkbox) checkbox.checked = !activateSub;
        } finally {
          if (loader) loader.hidden = true;
          if (secondaryCard) secondaryCard.classList.remove('is-secondary-loading');
          subToggleLabel.style.pointerEvents = '';
          subToggleLabel.style.opacity = '';
        }
        return;
      }

      const removeButton = event.target.closest('[data-remove-secondary]');
      const increaseButton = event.target.closest('[data-secondary-increase]');
      const decreaseButton = event.target.closest('[data-secondary-decrease]');

      if (removeButton) {
        const lineKey = removeButton.getAttribute('data-remove-secondary');
        const originalContent = removeButton.innerHTML;
        removeButton.disabled = true;
        removeButton.textContent = '...';

        try {
          await removeSecondaryProduct(lineKey);
        } catch (error) {
          console.error('[DH Cart Checkout] Error eliminando producto agregado', error);
          removeButton.disabled = false;
          removeButton.innerHTML = originalContent;
        }
        return;
      }

      if (increaseButton || decreaseButton) {
        const trigger = increaseButton || decreaseButton;
        const lineKey = trigger.getAttribute(increaseButton ? 'data-secondary-increase' : 'data-secondary-decrease');
        const targetItem = secondaryCartItems.find((item) => item.key === lineKey);
        if (!targetItem) return;

        const currentQuantity = Number(targetItem.quantity || 1) || 1;
        const nextQuantity = increaseButton ? currentQuantity + 1 : Math.max(1, currentQuantity - 1);
        if (nextQuantity === currentQuantity) return;

        const actionButtons = Array.from(secondaryProductsNode.querySelectorAll(`[data-secondary-increase="${lineKey}"], [data-secondary-decrease="${lineKey}"], [data-remove-secondary="${lineKey}"]`));
        actionButtons.forEach((button) => {
          button.disabled = true;
        });

        try {
          await updateSecondaryProductQuantity(lineKey, nextQuantity);
        } catch (error) {
          console.error('[DH Cart Checkout] Error actualizando cantidad del producto agregado', error);
          actionButtons.forEach((button) => {
            button.disabled = false;
          });
        }
      }
    });

    checkoutLink?.addEventListener('click', async (event) => {
      event.preventDefault();
      const targetHref = checkoutLink.href;
      const originalLabel = checkoutLink.textContent;

      checkoutLink.setAttribute('aria-busy', 'true');
      checkoutLink.textContent = 'Loading checkout...';

      // syncPrimaryProductForCheckout hace fetches (cart.js, cart/change.js, cart/add.js) sin
      // ningun timeout propio. Kaching dispara un header Clear-Site-Data en cada request que a
      // veces deja esos fetches colgados de forma indefinida (mismo problema ya documentado en
      // fetchPrimarySellingPlanInfo, que por eso usa AbortController con 4s) - sin este limite,
      // el boton de checkout se quedaba trabado en "Cargando checkout..." para siempre y el
      // cliente no podia avanzar a pagar (confirmado 2026-09-14). Pase lo que pase, despues de
      // 4s se avanza al checkout igual: es preferible ir con la ultima sincronizacion que haya
      // llegado a tiempo que dejar al cliente sin poder comprar.
      const syncWithTimeout = Promise.race([
        syncPrimaryProductForCheckout(),
        new Promise((resolve) => setTimeout(resolve, 4000))
      ]);

      try {
        await syncWithTimeout;
      } catch (error) {
        console.error('[DH Cart Checkout] Error sincronizando checkout', error);
      }
      window.location.assign(targetHref);
    });

    // Al volver con el boton "atras" del navegador desde /checkout, Chrome restaura esta pagina
    // desde el bfcache tal cual quedo al salir - con el boton todavia en "Cargando checkout..."
    // y aria-busy="true", porque nada lo resetea nunca (confirmado 2026-09-14: se veia asi el
    // drawer aunque el checkout en si no se hubiera colgado). "pageshow" con persisted=true es la
    // señal de que la pagina vino del bfcache, no de una carga nueva.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && checkoutLink) {
        checkoutLink.removeAttribute('aria-busy');
        checkoutLink.textContent = checkoutLinkDefaultLabel;
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !root.hidden) {
        closeDrawer();
      }
    });

    addButtons.forEach((button) => {
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const variantId = Number(button.dataset.variantId || 0);
        if (!variantId) return;
        button.disabled = true;
        const original = button.textContent;
        button.textContent = 'Adding...';
        try {
          const planInfo = upsellPlanMap[variantId];
          await addRecommendedVariant(variantId, planInfo ? planInfo.planId : 0);
          button.textContent = 'Added';
          setTimeout(() => {
            button.textContent = original;
            button.disabled = false;
          }, 900);
        } catch (err) {
          console.error('[DH Cart Checkout] Error agregando upsell', err);
          button.textContent = 'Error';
          setTimeout(() => {
            button.textContent = original;
            button.disabled = false;
          }, 1200);
        }
      });
    });

    window._dhCartOpenDrawer = openDrawer;
    if (window._dhPendingCartOpen) {
      window._dhPendingCartOpen = false;
      openDrawer();
    }

    // No tiene sentido sugerir como upsell el mismo producto que ya es el primario de esta pagina
    // (ej. estar en la pagina de MCT Fat Burner y que el carrusel del drawer ofrezca agregar MCT
    // Fat Burner otra vez) - ademas de ser redundante, si se agrega termina generando una segunda
    // linea del carrito para la misma variante (con selling_plan distinto al primario) que el
    // drawer no sabe mostrar bien y deja un hueco vacio (confirmado 2026-07-27).
    const primaryVariantIdForUpsell = getPrimaryVariantId();
    if (primaryVariantIdForUpsell) {
      featuredSlides.forEach((slide, index) => {
        const addBtn = slide.querySelector('[data-add-to-cart]');
        const slideVariantId = Number((addBtn && addBtn.dataset.variantId) || 0);
        if (slideVariantId && slideVariantId === primaryVariantIdForUpsell) {
          slide.remove();
          if (featuredDots[index]) featuredDots[index].remove();
        }
      });
      featuredSlides = Array.from(root.querySelectorAll('[data-featured-slide]'));
      featuredDots = Array.from(root.querySelectorAll('[data-featured-dot]'));
    }

    renderFeaturedCarousel();
    renderSecondaryProducts();
    updateProgressLockState(shouldUnlockProgress());
    syncFeaturedTrackHeight();
    sync();
    tick();
  });
})();
